import { createSelector } from "reselect";
import { RolePermissions } from "../../../../enums";
import { type RootState } from "../../../Application/globaltypes/redux";
import { intersection } from "lodash";
import { addContentToPackPermissions } from "enums/rights";

const getPermissions = (state: RootState) => state.userProfile.permissions;

export const hasPacksManagePermissionSelector = createSelector([getPermissions], (permissions) =>
  permissions.includes(RolePermissions.PacksManage),
);

export const hasAddContentToPackPermissionSelector = createSelector(
  [getPermissions],
  (permissions) => intersection(permissions, addContentToPackPermissions).length > 0,
);

export const activeViewTabSelector = (state: RootState) => state.packs.packContentTab.context.activeTab;

export const packContentTypeSelectSelector = (state: RootState) => {
  const contextSelector = state.packs.packContentTab.context;
  return contextSelector.entityType[contextSelector.activeTab];
};

export const itemsToDropSelector = (state: RootState) => state.packs.packContentTab.itemsToDrop;

export const itemsToDropFiltersSelector = (state: RootState) => state.packs.packContentTab.filters;
